/**
 * state format
 *  .applicationContext
 *      .ch {String}
 *      .ss {String}
 *      .cmp {String}
 *      .fullLocationSearchString {String}
 *  .gui
 *      .responsive {String}
 *          ['desktop',|'mobile']
 *      .currentStep {Number}
 *      .currentStepTitle {String}
 *      .currentEditingData {String}
 *      .onpopstateListeners {Object}
 *      .wizardNextautoWatchers {Object}
 *      .wizardButtonNavClicked {Boolean}
 *  .user
 *      .address
 *      .pv
 *      .city
 *      .postalCode
 *      .email
 *  .configuration
 *      .roofArea {Number}
 *      .roofOrientation {Number}
 *      .roofInclination {Number}
 *      .roofTipology {String}
 *      .roofMaterial {String}
 *      .floorsNumber {Number}
 *      .electricityConsumption {String}
 *      .electricityConsumptionPersone {String}
 *      .electricityConsumptionCost {Number}
 *      .houseUsage {String}
 *      .electricCar {Boolean} * 
 *  .map
 *      .refs
 *          .map {google.maps.Map}
 *          .polygon {google.maps.Polygon}
 *      .data {Object}
 *          ...
 *      .staticImageUrl {String}
 *  ...TODO...
 */

export default {
    applicationContext: {
        ch: null,
        ss: null,
        cmp: null,
        fullLocationSearchString: null
    },
    gui: {
        responsive: null,
        currentStep: null,
        currentStepTitle: null,
        currentEditingData: null,
        onpopstateListeners: {},
        wizardNextautoWatchers: {},
        wizardButtonNavClicked: false
    },
    user: {
        address: null,
        pv: null,
        city: null,
        postalCode: null,
        email: null
    },
    configuration: {
        tipo_installazione: null,
        dove: null,
        numero_stanze: null,
        numero_clima_per_stanza: null,
        numero_clima_per_stanza_mono9: null,
        numero_clima_per_stanza_mono12: null,
        numero_clima_per_stanza_mono18: null,
        numero_clima_per_stanza_dual9_9: null,
        numero_clima_per_stanza_dual9_12: null,
        numero_clima_per_stanza_trial9_9_9: null,
        numero_clima_per_stanza_trial9_9_12: null,
        marchi: null,
        scarico_4mt_discesa: null,
        unita_esterna_2_5mt: null,
        parete_cemento_pietra: null,
        quante_pareti_attraversare: null
    },
    map: {
        refs: {
            map: null,
            polygon: null
        },
        data: null,
        staticImageUrl: null
    },
    /**
     * Holds the installation quotations state
     *  .valutazione
     *      defined by the backend, immutable
     *  .uuid
     *      defined by the backend, immutable
     *  .selectedQuotation
     *      defined by the frontend user choices
     *  .selectedImpianto
     *      defined by the frontend user choices
     *  .basic
     *      defined by the backend and the frontend user choices
     */
    quotations: {
        valutazione: {
            basic: null
        },
        uuid: null, // 'bff78db4-c7af-4dd1-bab8-7165d305fd02'
        selectedQuotation: null, // ['basic']
        selectedImpianto: null, // ['basic'|'basic-accumulo'|'basic-s'|'basic-s-accumulo']
        basic: {
            total: null,
            options: {
                accumulatoreProposto: false
            }
        }
    },
    quotationsForm: {
        valid: false,
        nome: null,
        cognome: null,
        email: null,
        telefono: null,
        ragioneSociale: null,
        indirizzo: null,
        numerocivico: null,
        comune: null,
        cap: null,
        provincia: null,
        tipoImmobile: null,
        emailCommerciale: null
    }
};